import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import Spinner from "../../components/spinner";
import { useToaster } from "../../context/ToasterContext";
import "../../styles/payment-webview.scss";
import EqualSplitIcon from "../../assets/icons/equal.png";
import UnequalSplitIcon from "../../assets/icons/not-equal.png";
import { ReactComponent as DollarCircleIcon } from "../../assets/icons/dollar-circle.svg";
import { ReactComponent as QuestionMarkCircleIcon } from "../../assets/icons/question-mark-circle.svg";
import { useShopDetailsContext } from '../../context/ShopDetailsContext';
import { fetchShopDetailsByShopLink, getMinimumAmountForCurrency } from "../../utils/global";
import PoweredByComponent from "../../webview-components/powered-by";
import MerchantLogoHeader from "../../webview-components/merchant-logo-header";

const CreatePaymentLinkWithQr = () => {
  useEffect(() => {
    document.title = "Get a link & Start sharing - SuperCheckout";
  }, []);

  let { shop } = useParams();
  //console.log("useParams shopLink: " + shop);

  const { toaster } = useToaster();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [noOfPax, setNoOfPax] = useState(null);
  const [amount, setAmount] = useState("");
  const [shopDetails, setShopDetails] = useState({});
  const [is_superpay_enabled, set_is_superpay_enabled] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [paymentQr, setPaymentQr] = useState("");

  const [createOrderApi_loading, setCreateOrderApi_loading] = useState(false);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const { setShopDetailsContext } = useShopDetailsContext();

  const [step, setStep] = useState(0);
  const [animation, setAnimation] = useState("active");
  const steps = [
    { id: "amount" },
    { id: "payment_qr" },
  ];

  useEffect(() => {
    const fetchShopDetails = async () => {
      try {
        const response = await fetchShopDetailsByShopLink(shop);

        setShopDetails(response);

        setShopDetailsContext(prev => ({
          ...prev,
          user_image: response.user_image,
          shop_name: response.shop_name,
          meta_data: response.meta_data
        }));

        let atleast_1_paymode_selected = false;
        if(response.meta_data.pay_for_me === true || response.meta_data.multi_mode_single_pax === true || response.meta_data.fixed_price === true || response.meta_data.variable_price === true){
          atleast_1_paymode_selected = true;
        }

        if(response.meta_data){
          if(typeof response.meta_data.superpay !== 'undefined'){
            if(response.meta_data.superpay === true){
              set_is_superpay_enabled(true);

              if(atleast_1_paymode_selected === false){
                navigate("/"+ shop +"/superpay");
              }
            }
          }
        }

        setLoading(false);
      } catch (err) {
        console.log(err);
      } finally {
        //setLoading(false);

        setTimeout(function(){
          const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
          [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
        }, 100);
      }
    };

    setTimeout(function(){
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
    }, 100);

    fetchShopDetails();
  }, []);

  const createOrderApiCall = async () => {
    if(amount === '' || amount === null || amount === 0){
      toaster.error("Please enter total amount to be paid!");

      return;
    }
    else if(parseFloat(amount) < parseFloat(getMinimumAmountForCurrency(shopDetails.user_currency)) * 2){
      toaster.error("Sorry! The entered amount is below the minimum required to proceed with the transaction.");

      return;
    }
    
    try {
      setCreateOrderApi_loading(true);

      let orderData = {
        order_id: crypto.randomUUID(),
        cart_items: "",
        total_amount: amount,
        subtotal: amount,
        shipping: "0.00",
        tax: "0.00",
        discount: "0.00",
        meta_data: "",
      };

      let requestData = {
        order_data: orderData,
        currency: shopDetails.user_currency,
        merchant_shop: shop
      };

      let createOrderApiCallResponse = await api.post(
        `sdk/orders/create-payment-link`, JSON.stringify(requestData)
      );
      console.log(createOrderApiCallResponse);

      setCreateOrderApi_loading(false);

      if (
        (createOrderApiCallResponse.status === 200 ||
          createOrderApiCallResponse.status === 201) &&
        createOrderApiCallResponse.data
      ) {
        if (createOrderApiCallResponse.data) {
          localStorage.removeItem("sc_pn_fcmTokenSent");

          setPaymentLink(createOrderApiCallResponse.data.payment_link);
          setPaymentQr(createOrderApiCallResponse.data.qr_link);

          setStep(1);
        }
      } else {
        if (
          createOrderApiCallResponse.data.errorMessage &&
          createOrderApiCallResponse.data.errorMessage.length
        ) {
          toaster.error(createOrderApiCallResponse.data.errorMessage);
        } else {
          toaster.error("Something went wrong");
        }
      }
    } catch (error) {
      setCreateOrderApi_loading(false);
      
      console.log("Exception: ", error);

      toaster.error("Something went wrong");
    }
  };

  const goTo_paymentLink = (thisLink) => {
    let payment_link = thisLink;
    if (payment_link.includes("/checkout")) {
      const parts = payment_link.split("/checkout/");
      if (parts.length > 1) {
        navigate("/checkout/"+ parts[1]);
      }
    }
    else{
      window.location.href = thisLink;
    }
  }

  return (
    <>
      <div className="payment-page-wrapper">
        {loading && <Spinner />}

        {!loading && 
          <div>
            <div className="payment-form-wrapper">
              <div className="form-wrapper text-start mt-5">
                <MerchantLogoHeader shop_name={shopDetails.shop_name} user_image={shopDetails.user_image}></MerchantLogoHeader>

                <form id="payment-form">
                  <div className="typeform-container">
                    {steps.map((s, index) => {
                      if (s.id === "amount") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <div className="whiteCard mt-5">
                            <div className="input-wrapper mt-0 pt-0">
                              <label className="form-label">
                                <DollarCircleIcon className="DollarCircleIcon align-middle" />
                                {' '}
                                <span className="align-middle">Enter amount</span>
                              </label>

                              <div className="input-group mb-3">
                                <span className="input-group-text">{shopDetails.currency_with_symbol}</span>

                                <input type="number" id="amount" className="form-control" placeholder="e.g. 500" min="0" step="0.01" inputMode="decimal" value={amount || ''} disabled={loading} onChange={(e) => {
                                  setAmount(e.target.value);
                                }} />
                              </div>
                            </div>

                            <div className="">
                              <ButtonComponent
                                type="button"
                                id="get_payment_link_btn"
                                className="btn btn-primary btn-pool-shadow btn-pool-full"
                                disabled={createOrderApi_loading}
                                label={createOrderApi_loading ? "Please wait..." : "Start sharing"}
                                variant="primary"
                                size="md"
                                onClick={() => createOrderApiCall()}
                              ></ButtonComponent>
                            </div>
                          </div>
                        </div>
                      }
                      if (s.id === "payment_qr") {
                        return <div
                          key={s.id}
                          className={`step ${
                            step === index ? `active ${animation}` : ""
                          }`}
                        >
                          <div className="whiteCard mt-4 mb-3 text-center">
                            <div id="qr-container">
                              <div className="mb-3 text-center">
                                <p className="text-base font-bold">Please present the QR code below to the customer for payment</p>
                              </div>
                              
                              <img 
                                src={paymentQr}
                                alt="Payment QR Code" 
                                id="payment-qr-code"
                                className="h-auto netsPaymentQrCode"
                              />

                              <div className="input-wrapper mt-3" style={{marginBottom: "0px"}}>
                                <ButtonComponent
                                  type="button"
                                  id="go_to_payment_link_btn"
                                  onClick={() => goTo_paymentLink(paymentLink)}
                                  className="btn btn-primary btn-pool-shadow btn-pool-full"
                                  label="Start sharing"
                                  size="md"
                                  variant="primary"
                                ></ButtonComponent>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    })}
                  </div>
                </form>

                <PoweredByComponent></PoweredByComponent>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
};

export default CreatePaymentLinkWithQr;
